import { Dropdown, DropdownButton } from "react-bootstrap";

function MyDropDown(props: PropTypes) {
  return (
    <DropdownButton id="dropdown-basic-button" title={props.title}>
      {props.options?.map((option) => (
        <Dropdown.Item onClick={() => props.onClick(option)}>
          {option}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
}

type PropTypes = {
  options: string[] | undefined;
  onClick: (option: string) => void;
  title: string;
};

export default MyDropDown;
